<template>
  <a-modal
    title="发送OFFER"
    :confirmLoading="loading"
    :destroyOnClose="true"
    v-model="visible"
    @ok="handleOk"
    @cancel="close"
  >
    <a-form :form="form">
      <a-form-item label="入职人姓名" v-bind="formItemsLayout">
        <a-input disabled v-decorator="['name']" />
      </a-form-item>
      <a-form-item label="推荐职位" v-bind="formItemsLayout">
        <a-input disabled v-decorator="['post']" />
      </a-form-item>
      <a-form-item label="猎头顾问" v-bind="formItemsLayout">
        <a-input disabled v-decorator="['hunter_name']" />
      </a-form-item>
      <a-form-item label="佣金" v-bind="formItemsLayout">
        <a-input disabled v-decorator="['hunter_commission_value']" />
      </a-form-item>

      <a-form-item label="试用期" v-bind="formItemsLayout">
        <a-select
          v-decorator="[
            'probation',
            { rules: [{ required: true, message: '请设置试用期' }] },
          ]"
        >
          <template v-for="(item, index) in $store.state.config.probation">
            <a-select-option :key="index" :value="index">
              {{ item }}
            </a-select-option>
          </template>
        </a-select>
      </a-form-item>
      <a-form-item label="到岗时期" v-bind="formItemsLayout">
        <a-date-picker
          style="display: block"
          v-decorator="[
            'on_board_time',
            { rules: [{ required: true, message: '请设置到岗时期' }] },
          ]"
        ></a-date-picker>
      </a-form-item>
      <a-form-item label="年薪" v-bind="formItemsLayout">
        <a-input
          v-decorator="[
            'salary',
            { rules: [{ required: true, message: '请填写年薪' }] },
          ]"
        >
          <span slot="addonAfter">万</span>
        </a-input>
      </a-form-item>
      <a-form-item label="工作地点" v-bind="formItemsLayout">
        <a-input
          v-decorator="[
            'work_place',
            { rules: [{ required: true, message: '请填写工作地点' }] },
          ]"
        />
      </a-form-item>
      <a-form-item label="上传附件" v-bind="formItemsLayout">
        <a-upload
            name="file"
            :multiple="true"
            accept=".pdf,.doc,.docx,image/jpeg,image/jpg,image/png,.zip,.rar"
            :action="baseURL + '/common/file/upload'"
            :remove="remove"
            :data="{ token: token }"
              v-decorator="[
              'attachment',
              {
                getValueFromEvent: normFile,
                rules: [{ required: true, message: '请上传沟通附件'}]
              }
            ]"
          >
            <a-button>
              <a-icon type="link" /> 点击上传沟通记录
            </a-button>
          </a-upload>
        </a-form-item>
      <a-form-item label="备注" v-bind="formItemsLayout">
        <a-textarea :rows="6" v-decorator="['remark']"></a-textarea>
        <span slot="addonAfter">万</span>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
let baseURL = process.env.VUE_APP_BASEURL;
import { mapState } from "vuex";
export default {
  name: "FaildModal",
  data() {
    return {
      visible: false,
      record: {},
      baseURL: baseURL,
      loading: false,
      attachment: [],
      fileList:[],
      file:[],
      form: this.$form.createForm(this),
      formItemsLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 },
      },
    };
  },
  computed: {
    ...mapState(["token"])
  },
  methods: {
    show(record) {
      this.visible = true;
      this.record = record;
      this.$nextTick().then(() => {
        this.form.setFieldsValue({
          name: this.record.resume_name,
          post: this.record.job_name,
          hunter_name: this.record.hunter_name,
          hunter_commission_value: this.record.hunter_commission_value,
        });
      });
    },
    close() {
      this.visible = false;
    },
    normFile(info) {
      this.fileList = []
      console.log("Upload event:", info);
      if (Array.isArray(info)) {
        return info;
      }
      this.fileList = info.fileList
      console.log(this.fileList )
      const status = info.file.status;
      if (status === "done") {
        this.$message.success(`${info.file.name} 上传成功！`);
        this.file = [];
        info.fileList.forEach(item => {
          if (item.response && item.response.data) {
            this.file.push(item.response.data);
          }
        });
        console.log(this.file)
      } else if (status === "error") {
        this.$message.error(`${info.file.name} 上传失败！`);
      }
      return info && info.fileList;
    },
    remove (file) {
      let index = this.fileList.indexOf(file)
      this.fileList.splice(index,1)
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true;
          for(var i = 0;i< this.fileList.length;i++) {
            this.attachment.push({url:this.fileList[i].response.data.url,name:this.fileList[i].response.data.name,time:this.fileList[i].response.data.time})
          }
          try {
            await Api.order.offer({
              ...values,
              on_board_time: values.on_board_time.format("YYYY-MM-DD"),
              post_id: this.record.id,
              attachment: this.attachment
            });
            this.close();
            this.$emit("ok");
          } catch (e) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tags {
  margin-bottom: 20px;
  .tag {
    line-height: 30px;
    padding: 0 15px;
    height: 30px;
    font-size: 12px;
    border-radius: 4px;
    margin-bottom: 12px;
    border: 1px solid rgba(220, 223, 230, 1);
  }
}
::v-deep.ant-upload-list-item-info {
  height: 100%;
    padding: 0 30px 0 4px;
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
}
::v-deep.ant-upload-list-item-card-actions {
    position: absolute;
    right: 0;
    opacity: 1;
}
::v-deepa {
  display: inline-block;
    width: 30px;
    text-align: center;
}
</style>
